import { OpportunityReviewBoardGroupingPgKpi } from '@models/OpportunityReview';
import { GroupContext } from '@utils/userPreferencesUtils/Types';
import { OpportunityReviewTableGroupRow } from './OpportunityReviewTableGroupRow';
import { GrowthTypes } from '@components/comparison-growth-selector/Types';
import { ColumnConfig } from '@components/design/migrated/Table';

interface Props {
  opportunityReviewGroups: OpportunityReviewBoardGroupingPgKpi[];
  currencySymbol: string;
  columns: ColumnConfig[];
  sortedColumn: string;
  selectedGrowthType: GrowthTypes;
  context: GroupContext;
}

export const OpportunityReviewTableGroupRows: React.FC<Props> = ({
  opportunityReviewGroups,
  columns,
  sortedColumn,
  currencySymbol,
  selectedGrowthType,
  context,
}) => {
  return (
    <>
      {opportunityReviewGroups.map(({ groupDetails, groupKpis }) => (
        <OpportunityReviewTableGroupRow
          key={groupDetails.groupName}
          groupDetails={groupDetails}
          opportunityReviewBoardPgs={groupKpis}
          currencySymbol={currencySymbol}
          sortedColumn={sortedColumn}
          columns={columns}
          selectedGrowthType={selectedGrowthType}
          context={context}
        ></OpportunityReviewTableGroupRow>
      ))}
    </>
  );
};
